import React, { useState } from 'react'
import Menu from './Menu/Menu'
import Points from './Points/Points'
import Logo from './Logo/Logo'
import styles from './NavBar.module.scss'
import MenuIcon from './Menu/MenuIcon'

const NavBar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <div className={styles.navbar}>
        <div className={styles.left}>
          <div className={styles.menuIcon}>
            <MenuIcon
              isMenuOpen={isMenuOpen}
              handleMenuClick={handleMenuClick}
            />
          </div>
          <div className={styles.logoMobile}>
            <Logo />
          </div>
        </div>
        <div className={styles.center}>
          <Logo />
        </div>
        <div className={styles.right}>
          <Points />
        </div>
      </div>

      <Menu isMenuOpen={isMenuOpen} />
    </>
  )
}

export default NavBar
